import { Link, useNavigate, useParams } from 'react-router-dom';
import { useLazyGetSignalQuery } from '../api/checkerApi';
import { SignalDisplay } from '../components/SignalDisplay';
import { useEffect, useState } from 'react';
import { SignalType } from '../api/types';
import styled from 'styled-components';
import { BackIcon } from '../../../assets/icons/back';
import brandConfig from '../../../config/brand';

export const SignalCheck = () => {
  const [addresses, setAddresses] = useState<SignalType[]>([]);
  const { postcode } = useParams<{ postcode: string }>();
  const [getSignal, { isFetching }] = useLazyGetSignalQuery();
  const [hasError, setHasError] = useState(false);
  const navigate = useNavigate();

  const onGetSignal = async () => {
    setHasError(false);
    try {
      const res = await getSignal({ postCode: postcode || '' }).unwrap();
      setAddresses(res.Availability);
    } catch (error) {
      console.error(error);
      setHasError(true);
    }
  };

  useEffect(() => {
    onGetSignal();
  }, [postcode]);

  return (
    <Container>
      <Wrapper>
        <TopWrapper>
          <IconWrapper onClick={() => navigate('/postcode')}>
            <BackIcon size={20} />
          </IconWrapper>
          <StyledLink to="https://farmstream.co.uk">
            <StyledLogo src={brandConfig.logo} alt={brandConfig.displayName} />
          </StyledLink>
        </TopWrapper>
        {isFetching ? (
          <StatusText>Checking signal for {postcode}…</StatusText>
        ) : hasError ? (
          <StatusText>
            We couldn't check signal for “{postcode}”. Please make sure the postcode is valid and{' '}
            <RetryLink type="button" onClick={onGetSignal}>
              try again
            </RetryLink>
            .
          </StatusText>
        ) : (
          <SignalDisplay addresses={addresses} />
        )}
      </Wrapper>
    </Container>
  );
};

const StatusText = styled.p`
  text-align: center;
  padding: 1.5rem 0;
  color: ${({ theme }) => theme.colors.gray900};
`;

const RetryLink = styled.button`
  background: none;
  border: none;
  padding: 0;
  color: ${({ theme }) => theme.colors.primary};
  font: inherit;
  text-decoration: underline;
  cursor: pointer;
`;

const StyledLogo = styled.img`
  width: 4rem;
`;
const StyledLink = styled(Link)`
  cursor: pointer;
`;

const TopWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const IconWrapper = styled.div`
  padding: 0.5rem;
  cursor: pointer;
`;

const Wrapper = styled.div`
  max-width: 40rem;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 2rem;
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: 0.5rem;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);

  @media (max-width: 768px) {
    padding: 1rem 0.5rem;
    width: 100%;
  }
`;

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  padding: 1rem;
  width: 100%;
  background-color: ${({ theme }) => theme.colors.primary};

  @media (max-width: 850px) {
    height: unset;
    padding: 0.5rem;
  }
`;
